import { isApp, isMobile, uniframeReady, webapi } from '@spot-fe/utils';
import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { IUserInfo } from '../provider/user-info';

export interface HeaderProps {
  locale?: string;
  locales?: string[];
  userInfo?: IUserInfo;
  onLanguageChange?: (locale: string) => void;
  uniframeHasReady?: boolean;
}

export const execLogout = () => {
  return webapi.post(`/logout`, {});
};

export const Header: FC<HeaderProps> = ({
  locale,
  onLanguageChange,
  userInfo,
  uniframeHasReady
}) => {
  const [initialized, setInitialized] = useState(false);
  const userInfoRef = useRef(userInfo);
  const languageChange = useCallback(
    (newLocale) => {
      onLanguageChange?.(newLocale);
    },
    [onLanguageChange]
  );
  console.log('userInfo', userInfo);

  useEffect(() => {
    // 在这里获取body的dom是因为外层判断移动端有问题
    const bodyWrapperEle = document.getElementById('root-placeholder');
    const wrapperEle = document.getElementById('__bybit_uniframe_header__');

    if (isMobile()) {
      bodyWrapperEle?.classList.add('root-placeholder-m');
    }
    if (wrapperEle && isApp()) {
      bodyWrapperEle?.classList.add('root-placeholder-app');
      wrapperEle.style.display = 'none';
      return;
    }

    
    userInfoRef.current = userInfo;
    if (!uniframeHasReady) return;
    uniframeReady().then(() => {
      (window as any)?.BybitUniFrame.ready(({ header }) => {
        const { LANGUAGE, USER_INFO } = header.properties;

        // 设置语言
        header.init({ containerId: '__bybit_uniframe_header__' }).then(() => {
          // monitor.mark('metric_uni_header_ready', monitorTypes.PAGE_START);
          header.setProperty(LANGUAGE, locale).setProperty(USER_INFO, userInfoRef.current);

          setInitialized(true);
        });
      });
    });
  }, [locale, userInfo, uniframeHasReady]);

  useEffect(() => {
    if (!initialized) return;

    uniframeReady().then(() => {
      (window as any)?.BybitUniFrame.ready(({ header }) => {
        const { LOGOUT, LANGUAGE_CHANGE } = header.events;
        header.subscribeEvent(LOGOUT, async () => {
          try {
            await execLogout();
            window.location.reload();
          } catch (e) {
            console.error('logout error', e);
          }
        });
        header.subscribeEvent(LANGUAGE_CHANGE, (locale) => {
          languageChange?.(locale);
        });
      });
    });
  }, [initialized, languageChange]);

  useEffect(() => {
    localStorage.setItem('BYBIT_LANG_KEY', locale || 'en');
    if (!initialized) return;

    if ((window as any)?.BybitUniFrame?.header) {
      (window as any)?.BybitUniFrame.header.setProperty('language', locale || 'en');
    }
  }, [initialized, locale]);
  return null;
};

export { default as HeaderScript } from './header-script';
